import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {useEffect, useState} from 'react';
import { CreateDepartment, UpdateDepartment } from '../../../../reduxToolkit/Department/DepartmentApi';
import {CustomTextField} from "../../../../components/CustomTextField";
import DivContainerBody from "../../../../components/DivContainerBody";
import CustomModal from "../../../../components/Modal/CustomModal";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 * AddNewDepartmentModal Component
 *
 * This modal allows users to create a new department or update an existing one.
 *
 * Props:
 * @param {boolean} isUpdate - Determines whether the modal is in update mode.
 * @param {Object} data - Contains department data when updating.
 * @param {Function} onHide - Function to close the modal.
 *
 * State:
 * @state {string} workshiftName - Stores the department name input.
 * @state {string} nameError - Stores validation errors for the name field.
 * @state {boolean} submitClicked - Tracks whether the submit button was clicked.
 *
 * Functions:
 * @function handleNameChange - Validates and updates the department name state.
 * @function handleSubmit - Dispatches either CreateDepartment or UpdateDepartment based on mode.
 *
 * @returns {JSX.Element} A modal component for adding or updating a department.}
 * @constructor
 */

const AddNewDepartmentModal = (props) => {
    const { setModified ,modified,onHide,setIsUpdate,isUpdate,setData } = props
    const { t } = useTranslation();
    const [workshiftName, setWorkShiftName] = useState('');
    const [nameError, setNameError] = useState('');
    const [submitClicked, setSubmitClicked] = useState(false);
    const [emptyFields, setEmptyFields] = useState(false);

    const dispatch = useDispatch();

    const handleChange = (e) => {
        setWorkShiftName(e.target.value);
    };

    const resetValues = () => {
        setWorkShiftName('');
        setEmptyFields(false)
        setIsUpdate(false)
    };

    const handleSubmit = () => {
        if(workshiftName === ''){
            setEmptyFields(true)
        }

        if (isUpdate) {
            const data = {
                id: props?.data?.id,
                name: workshiftName,
            };
            if (workshiftName) {
                dispatch(UpdateDepartment(data)).then(({payload:{data:{success}}})=>{
                    if(success){
                        onHide();
                        setModified(true)
                        setWorkShiftName('');
                        setEmptyFields(false)
                        setData(null)
                        setIsUpdate(false)
                    }
                });
            } else {
                setSubmitClicked(true);
            }
        }
        else {
            if (workshiftName) {
                const data = {
                    name: workshiftName,
                };
                dispatch(CreateDepartment(data)).then(({payload:{data:{success}}})=>{
                    if(success){
                        onHide();
                        setModified(true)
                        setWorkShiftName('');
                        setEmptyFields(false)
                        setIsUpdate(false)
                    }
                });
            }
            else {
                setSubmitClicked(true);
            }
        }
    };

    useEffect(() => {
       if (isUpdate ){
           setWorkShiftName(props?.data?.name);
       }


    }, [isUpdate]);

    return (

        <CustomModal
            {...props}
            title={isUpdate ? t('update_department') : t('create_new_department')}
            size='md'
            onConfirm={() => { handleSubmit() }}
            onHide={() => {onHide(); resetValues();}}
            classNameBody="pt-2"
        >
                <DivContainerBody>
                    <div className={"mt-3"}>
                        <CustomTextField
                            id='txt_and_workshiftName'
                            name='workshiftName'
                            value={workshiftName}
                            trans='name'
                            emptyFields={emptyFields}
                            required={true}
                            onChange={handleChange}
                            helperText={nameError}
                        />
                    </div>

                </DivContainerBody>
        </CustomModal>
    );
};

export default AddNewDepartmentModal;
